import {
    AllSubSteps,
    ApplicationInformationSubSteps,
    AppStructure,
    MainSteps,
    PaymentSubSteps,
    PersonalDetailsSubSteps,
    ProductSelectionSubSteps,
    SummarySubSteps,
} from '@models/config/app-structure.model';
import {
    ApplicationInformationRoutes,
    AppStepRoutes,
    PaymentRoutes,
    PersonalDetailsRoutes,
    ProductSelectionRoutes,
    SubmissionRoutes,
    SummaryRoutes,
} from 'app/enums/config/app-routing.enum';

export const appStepsConfig: AppStructure = {
    steps: [
        {
            step: MainSteps.PERSONAL_DETAILS,
            path: AppStepRoutes.PERSONAL_DETAILS,
            title: 'Personal Details',
            description: 'Enter your contact and identity information',
            icon: 'pi pi-user',
            subSteps: [
                {
                    step: PersonalDetailsSubSteps.PERSONAL_INFORMATION,
                    path: PersonalDetailsRoutes.PERSONAL_INFORMATION,
                    title: 'Personal Information',
                    icon: 'pi pi-id-card',
                },
                // IAPP2-1741: Finance Information substep removed (all fields removed)
                // {
                //     step: PersonalDetailsSubSteps.FINANCE_INFORMATION,
                //     path: PersonalDetailsRoutes.FINANCE_INFORMATION,
                //     title: 'Finance Information',
                //     icon: 'pi pi-wallet',
                // },
                {
                    step: PersonalDetailsSubSteps.RESIDENTIAL_INFORMATION,
                    path: PersonalDetailsRoutes.RESIDENTIAL_INFORMATION,
                    title: 'Residential Information',
                    icon: 'pi pi-home',
                },
                {
                    step: PersonalDetailsSubSteps.MAILING_ADDRESS,
                    path: PersonalDetailsRoutes.MAILING_ADDRESS,
                    title: 'Purchased Property Address',
                    icon: 'pi pi-envelope',
                },
                {
                    step: PersonalDetailsSubSteps.CONTACT_INFORMATION,
                    path: PersonalDetailsRoutes.CONTACT_INFORMATION,
                    title: 'Contact Information',
                    icon: 'pi pi-phone',
                },
                {
                    step: PersonalDetailsSubSteps.RESIDENCY_AND_IDENTIFICATION,
                    path: PersonalDetailsRoutes.RESIDENCY_AND_IDENTIFICATION,
                    title: 'Residency and Identification',
                    icon: 'pi pi-globe',
                },
                {
                    step: PersonalDetailsSubSteps.IDENTITY_VERIFICATION_CONSENT,
                    path: PersonalDetailsRoutes.IDENTITY_VERIFICATION_CONSENT,
                    title: 'Identity Verification Consent',
                    icon: 'pi pi-verified',
                },
            ],
        },
        {
            step: MainSteps.PRODUCT_SELECTION,
            path: AppStepRoutes.PRODUCT_SELECTION,
            title: 'Product Selection',
            description: 'Choose your coverage type and options',
            icon: 'pi pi-shopping-cart',
            subSteps: [
                {
                    step: ProductSelectionSubSteps.INTRO,
                    path: ProductSelectionRoutes.INTRO,
                    title: 'Section Recap',
                    icon: 'pi pi-flag',
                    requiresForm: false,
                },
                {
                    step: ProductSelectionSubSteps.PRODUCT_SELECTION,
                    path: ProductSelectionRoutes.PRODUCT_SELECTION,
                    title: 'Product Selection',
                    icon: 'pi pi-shopping-cart',
                },
            ],
        },
        {
            step: MainSteps.APPLICATION_INFORMATION,
            path: AppStepRoutes.APPLICATION_INFORMATION,
            title: 'Application Information',
            description: 'Specify beneficiaries and accept agreements',
            icon: 'pi pi-users',
            subSteps: [
                {
                    step: ApplicationInformationSubSteps.OWNER,
                    path: ApplicationInformationRoutes.OWNER,
                    title: 'Owner',
                    icon: 'pi pi-user',
                },
                {
                    step: ApplicationInformationSubSteps.BENEFICIARY,
                    path: ApplicationInformationRoutes.BENEFICIARY,
                    title: 'Beneficiary',
                    icon: 'pi pi-user-plus',
                },
                {
                    step: ApplicationInformationSubSteps.EXISTING_INSURANCE,
                    path: ApplicationInformationRoutes.EXISTING_INSURANCE,
                    title: 'Existing Insurance',
                    icon: 'pi pi-file-check',
                },
                {
                    step: ApplicationInformationSubSteps.EXISTING_INSURANCE_REPLACEMENT,
                    path: ApplicationInformationRoutes.EXISTING_INSURANCE_REPLACEMENT,
                    title: 'Replacement Coverage',
                    icon: 'pi pi-file-check',
                },
                {
                    step: ApplicationInformationSubSteps.STATEMENTS_AND_AGREEMENTS,
                    path: ApplicationInformationRoutes.STATEMENTS_AND_AGREEMENTS,
                    title: 'Statements and Agreements',
                    icon: 'pi pi-shield',
                },
            ],
        },
        {
            step: MainSteps.SUMMARY,
            path: AppStepRoutes.SUMMARY,
            title: 'Summary',
            description: 'Review your application before submission',
            icon: 'pi pi-list',
            subSteps: [
                {
                    step: SummarySubSteps.SUMMARY,
                    path: SummaryRoutes.SUMMARY,
                    title: 'Summary',
                    icon: 'pi pi-list',
                    requiresForm: false,
                },
            ],
        },
        {
            step: MainSteps.PAYMENT,
            path: AppStepRoutes.PAYMENT,
            title: 'Payment',
            description: 'Configure payment methods',
            icon: 'pi pi-credit-card',
            subSteps: [
                {
                    step: PaymentSubSteps.INTRO,
                    path: PaymentRoutes.INTRO,
                    title: 'Almost There',
                    icon: 'pi pi-flag',
                    requiresForm: false,
                },
                {
                    step: PaymentSubSteps.PAYMENT_INFORMATION,
                    path: PaymentRoutes.PAYMENT_INFORMATION,
                    title: 'Payment Information',
                    icon: 'pi pi-info-circle',
                },
                {
                    step: PaymentSubSteps.PRIMARY_PAYMENT_METHOD,
                    path: PaymentRoutes.PRIMARY_PAYMENT_METHOD,
                    title: 'Primary Payment Method',
                    icon: 'pi pi-credit-card',
                },
                {
                    step: PaymentSubSteps.SECONDARY_PAYMENT_METHOD,
                    path: PaymentRoutes.SECONDARY_PAYMENT_METHOD,
                    title: 'Secondary Payment Method',
                    icon: 'pi pi-wallet',
                },
                {
                    step: PaymentSubSteps.ACH_DISCLAIMER,
                    path: PaymentRoutes.ACH_DISCLAIMER,
                    title: 'Payment Consent',
                    icon: 'pi pi-file',
                },
            ],
        },
        {
            step: MainSteps.SUBMISSION,
            path: AppStepRoutes.SUBMISSION,
            title: 'Submit',
            description: 'Review and submit your application',
            icon: 'pi pi-check-circle',
            subSteps: [
                {
                    step: PaymentSubSteps.FINAL_CONSENTS,
                    path: SubmissionRoutes.FINAL_CONSENTS,
                    title: 'STEPS.PAYMENT.SUBSTEPS.FINAL_CONSENTS.TITLE',
                    icon: 'pi pi-check-square',
                },
                {
                    step: PaymentSubSteps.SUBMIT,
                    path: SubmissionRoutes.SUBMIT,
                    title: 'Submit',
                    icon: 'pi pi-check-circle',
                },
            ],
        },
    ],
};

export function getSubStepTitle(mainStep: MainSteps, subStep: AllSubSteps): string {
    const step = appStepsConfig.steps.find((step) => step.step === mainStep);
    const sub = step?.subSteps.find((stepSubStep) => stepSubStep.step === subStep);
    return sub?.title ?? '';
}
